import { AxiosResponse } from 'axios';
import { bookmakerList, bookmakerStopBettingAll, bookmakerUpdate } from '@/api/bookmaker';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IBookmakerApiListResponse, IBookmakerStopBettingAllResponse, IBookmakerUpdateParams, IListParams } from '@/types';

export const bookmakerService = {
    async list(params: IListParams<Record<string, any>>): Promise<AxiosResponse<IBookmakerApiListResponse>> {
        try {
            const response = await baseListService<IBookmakerApiListResponse>(bookmakerList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Bookmaker API Error:', e);
            throw new AppError(`Unable to load bookmaker list, request error`, { cause: e });
        }
    },

    async update(params: IBookmakerUpdateParams): Promise<AxiosResponse<{ success: boolean }>> {
        try {
            return await bookmakerUpdate(params);
        } catch (e) {
            console.error('Bookmaker Update API Error:', e);
            throw new AppError(`Unable to update bookmaker, request error`, { cause: e });
        }
    },

    async stopBettingAll(): Promise<AxiosResponse<IBookmakerStopBettingAllResponse>> {
        try {
            return await bookmakerStopBettingAll();
        } catch (e) {
            console.error('Bookmaker Stop Betting All API Error:', e);
            throw new AppError(`Unable to stop betting for all bookmakers, request error`, { cause: e });
        }
    },
};
